const glimmrProductDiagram = "/_app/immutable/assets/glimmr-product-diagram.CjXUwnFL.png";
export {
  glimmrProductDiagram as default
};
